import { lazy } from 'react';

const ManufactureRecordsManufacturerConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/consult/manufacture-records',
			component: lazy(() => import('./ManufactureRecordsContainer'))
		}
	]
};

export default ManufactureRecordsManufacturerConfig;
